import {useMediaQuery} from '@mui/material'
import {FC, useEffect, useMemo, useRef} from 'react'
import {NavLink, useNavigate} from 'react-router-dom'
import {useDialogsUnreadCount} from 'entities/messages'
import {useUser} from 'entities/user'
import {displayCount} from 'shared/lib/entity'
import {UserStatus} from 'shared/types'
import {Tooltip} from 'shared/ui/tooltip'
import {sidebarList} from './config'
import styles from './styles.module.scss'

const debounceScrollMs = 200

export const Sidebar: FC<{className?: string}> = ({className}) => {
  const navigate = useNavigate()
  const is1440p = useMediaQuery(`(max-width: ${styles.is1440p})`)
  const unreadMessages = useDialogsUnreadCount()
  const sidebarLinksRef = useRef<HTMLDivElement>(null)
  let timer: number
  const {status} = useUser()
  const isActive = useMemo(() => status === UserStatus.ACTIVE, [status])
  const linksList = isActive ? sidebarList : sidebarList.filter(({id}) => id === 'profile')

  const handleScroll = () => {
    if (sidebarLinksRef.current) {
      sidebarLinksRef.current.style.pointerEvents = 'none'
      clearTimeout(timer)

      timer = window.setTimeout(() => {
        if (sidebarLinksRef.current) {
          sidebarLinksRef.current.style.pointerEvents = 'unset'
        }
      }, debounceScrollMs)
    }
  }

  useEffect(() => {
    if (sidebarLinksRef.current) {
      sidebarLinksRef.current.addEventListener('wheel', handleScroll)
    }

    return () => {
      if (sidebarLinksRef.current) {
        sidebarLinksRef.current.removeEventListener('wheel', handleScroll)
      }
    }
  }, [])

  return (
    <div className={`${styles.sidebar} ${className}`} ref={sidebarLinksRef}>
      <div className={styles.sidebarLinks}>
        {linksList.map(({id, to, text, tooltip, iconDefault, iconActive, key}) =>
          <div key={key} className={styles.linkWrapper} onClick={() => navigate(to)}>
            <NavLink to={to} className={({isActive}) => (isActive ? `${styles.active} ` : '') + styles.link}>
              {({isActive}) => (
                <div
                  className={`${styles.content} ${isActive ? styles.appSemiBoldDisplayXS : styles.appRegularDisplayXS}`}>
                  {!is1440p
                    ? <>
                      <div className={styles.icon}>{isActive ? iconActive : iconDefault}</div>
                      <span className={styles.text}>{text}</span>
                    </>
                    : <Tooltip title={<div className={styles.tooltipHeader}>{tooltip}</div>} placement='right'>
                      <div className={styles.icon}>{isActive ? iconActive : iconDefault}</div>
                    </Tooltip>
                  }
                  {id === 'messages' && unreadMessages ? <div className={`${styles.notice} ${styles.appBoldS}`}>
                    {displayCount(unreadMessages)}
                  </div> : null}
                </div>
              )}
            </NavLink>
          </div>
        )}
      </div>
    </div>
  )
}